import styled from "styled-components";

export const LoginPhoneFirstStepStyled = styled.div`
  /* margin-bottom: 48px; */
  overflow: hidden;

  .LoginPhoneFirstStep__input-phone {
    direction: ltr;
    font-weight: bold;
    font-size: 2.2em;
    text-align: center;
    margin-top: 24px;
  }

  .LoginPhoneFirstStep__input-code {
    direction: ltr;
    text-align: left;
    letter-spacing: 39px;
    font-size: 2.2em;
    font-weight: bold;
    padding-left: 10px;
    margin-top: 24px;
    padding-right: 10px;
  }

  .LoginPhoneFirstStep__input-code__boxes {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    /* background-color: gray; */
    z-index: 2;
    height: 48px;

    .LoginPhoneFirstStep__input-code__boxes__inner {
      width: 36px;
      height: 100%;
      border-radius: 5px;
      background-color: white;
    }
  }
`;
export const ProcessAlertContStyled = styled.div`
  display: flex;
  flex-direction: row;
  border: 2px solid
    ${(props) => (props.color === "red" ? "#ed5565" : "#48cfad")};
  border-radius: 14px;
  margin: 15px 0;
`;
export const RightColor = styled.div`
  width: 10%;
  /* border: 1px solid #ed5565; */
  background-color: ${(props) =>
    props.color === "red" ? "#ed5565" : "#48cfad"};
  border-radius: 0 10px 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color:#fff ;
  font-size:20px;
`;

export const AlertText = styled.div`
  width: 90%;
  margin: 5px;
  text-align: right;
`;
